import { get, patch, post, remove } from '@/api/base'

const companiesApi = {
  create: async params => {
    const response = await post({
      path: 'admin/companies',
      params,
    })
    return response.success ? response.data.company : null
  },
  delete: async companyUuid => {
    return await remove({
      path: `admin/companies/${companyUuid}`,
    })
  },
  get: async companyUuid => {
    const response = await get({
      path: `admin/companies/${companyUuid}`,
    })
    return response.success ? response.data.company : null
  },
  getAll: async () => {
    const response = await get({
      path: `admin/companies`,
    })
    return response.success ? response.data.companies : []
  },
  getCompanies: async params => {
    const response = await get({
      path: `admin/companies`,
      params,
    })
    return response.success
      ? {
          companies: response.data.companies,
          pagination: response.data.meta.pagination,
        }
      : null
  },
  update: async (companyUuid, params) => {
    return await patch({
      path: `admin/companies/${companyUuid}`,
      params,
    })
  },
}

export default companiesApi
